import React from "react";
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const StartStatus = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let start = findArray(data?.results?.currentExtendedInfos, { ei_code: ['START_INDIC'] })?.ei_value
    let color = ''
    let status = ''

    if(start === 'RED')
    {
        status = 'Wait'
        color = 'red'
    }
    else if (start === 'YELLOW')
    {
        status = 'Ready'
        color = 'yellow'
    }
    else if (start === 'GREEN')
    {
        status = 'GO'
        color = 'green'
    }

    return (
        <div className="fw-bold" style={{ display: 'inline-block'}}>
            <Label data='LabelStartStatus' sport={mirs_discipline}/>&ensp;<l style={{ background: `${color}`}}>{start ? status : ''} </l>
        </div>   
    )
}

export default StartStatus;